import type { IssuedQuoteVersion } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatKrw } from '@/shared/lib';

interface QuoteAmountBreakdownProps {
  readonly version: IssuedQuoteVersion;
}

/**
 * 발행본 금액 구성(SUPER-86 spec §7) — 상품 금액과 배송비(배송지 N곳)를 나눠 적는다. 금액은 계약 값(`productAmount`·
 * `shippingAmount`, `splitQuoteAmounts` 단일 원천)이고, 배송지 수는 배송비 줄 수다. 배송비 줄이 없으면 배송비 0원.
 * 내 견적 상세·주문하기·내 주문 상세의 합계 머리 아래에 같은 모양으로 놓인다.
 */
export const QuoteAmountBreakdown = ({ version }: QuoteAmountBreakdownProps): ReactElement => {
  const destinationCount = version.lines.filter((line) => line.kind === 'SHIPPING').length;
  return (
    <ul aria-label="금액 구성" className="flex flex-col gap-1.5 text-sm">
      <li className="flex justify-between gap-4">
        <span className="text-muted-foreground">상품 금액</span>
        <span className="tabular-nums">{formatKrw(version.productAmount)}</span>
      </li>
      <li className="flex justify-between gap-4">
        <span className="text-muted-foreground">
          {destinationCount > 0 ? `배송비 · 배송지 ${destinationCount}곳` : '배송비'}
        </span>
        <span className="tabular-nums">{formatKrw(version.shippingAmount)}</span>
      </li>
    </ul>
  );
};
